export default __webpack_public_path__ + "static/media/01-rock-dx.be668d98.gif";